export default "__VITE_ASSET__BHgD9UZp__"